import { Image } from "uikit-react";

const CommentsSection = ({
  register,
  isWorkOrderUpdateDisabled,
  attachmentList,
  handleDragOver,
  handleDrop,
  handleFilesSelected,
  handleRemoveFile,
}) => {
  return (
    <div className="uk-width-1-1 uk-margin-top no-print">
      <div className="uk-card uk-card-default uk-card-small" style={isWorkOrderUpdateDisabled ? { opacity: 0.6 } : {}}>
        <div className="uk-card-header">
          <h4 className="uk-margin-remove">Comments</h4>
        </div>

        <div className="uk-card-body">
          <div className="uk-grid-small" data-uk-grid>
            <div className="uk-width-1-1">
              <label className="uk-form-label">Comment</label>
              <div className="uk-form-controls">
                <textarea
                  className="uk-textarea"
                  rows="3"
                  {...register("description")}
                  disabled={isWorkOrderUpdateDisabled}
                ></textarea>
              </div>
            </div>

            <div className="uk-width-1-1">
              <label className="uk-form-label">Add an Attachment</label>

              <div
                className="hms-upload-card uk-card uk-card-default uk-card-small"
                onDragOver={handleDragOver}
                onDrop={handleDrop}
              >
                <div className="uk-card-body uk-padding-small">
                  <div className="uk-flex uk-flex-middle uk-flex-between">
                    {/* Left: Icon + text */}
                    <div className="uk-flex uk-flex-middle" style={{ gap: 12 }}>
                      <div className="hms-upload-icon">
                        <Image src="/images/upload-image.svg" alt="Upload" />
                      </div>
                      <div>
                        <div className="hms-upload-title">Upload files</div>
                        <div className="hms-upload-subtitle uk-text-meta">
                          Drag &amp; drop images here or click <strong>Browse files</strong>
                        </div>
                      </div>
                    </div>

                    {/* Right: Browse button (keeps UIkit form-custom) */}
                    <div className="uk-form-custom">
                      <button
                        type="button"
                        className="uk-button uk-button-default hms-upload-btn"
                      >
                        Browse files
                      </button>
                      <input
                        type="file"
                        multiple
                        accept="image/*"
                        onChange={(evt) => handleFilesSelected(evt.target.files)}
                        disabled={isWorkOrderUpdateDisabled}
                      />
                    </div>
                  </div>

                  {attachmentList && attachmentList.length > 0 && (
                    <div className="hms-upload-thumbs uk-margin-small-top">
                      <span className="uk-text-meta uk-display-block">
                        {attachmentList.length} file
                        {attachmentList.length > 1 ? "s" : ""} selected
                      </span>

                      <div
                        className="uk-grid-small uk-child-width-1-4@s uk-child-width-1-6@m"
                        data-uk-grid
                      >
                        {Array.from(attachmentList).map((file, idx) => (
                          <div key={`${file.name}-${idx}`} style={{ position: "relative" }}>
                            <div className="hms-upload-thumb">
                              <img
                                src={URL.createObjectURL(file)}
                                alt={file.name}
                                className="hms-upload-thumb-img"
                              />
                            </div>
                            <button
                              type="button"
                              className="hms-upload-thumb-remove"
                              onClick={() => handleRemoveFile(idx)}
                              disabled={isWorkOrderUpdateDisabled}
                            >
                              &times;
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <progress
                id="js-progressbar"
                className="uk-progress"
                value="0"
                max="100"
                hidden
              ></progress>
            </div>
          </div>
        </div>

        <div className="uk-card-footer uk-text-right uk-padding-small">
          <button className="uk-button hms-btn hms-red-btn" type="submit" disabled={isWorkOrderUpdateDisabled}>
            Add Comment
          </button>
        </div>
      </div>
    </div>
  );
};

export default CommentsSection;
